// this is the permission state of a currently shared document
import { useAtom, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import {
	$documentPermissions,
	$updateDocumentPermissions,
	$updatePublishMode,
} from "../../internal/document/sharing/permissions.atom";

export const useDocumentPermissions = (documentId: string, workspaceName: string | undefined) => {
	const [permissionsState] = useAtom(
		loadable($documentPermissions({ documentId, workspaceName }))
	);
	const updatePermissions = useSetAtom($updateDocumentPermissions);
	const updatePublishMode = useSetAtom($updatePublishMode);

	return {
		isLoading: permissionsState.state === "loading",
		permissionsState:
			permissionsState.state === "hasData"
				? permissionsState.data
				: {
						isPublished: false,
						hasPublishedPassword: false,
						userPermissions: new Map(),
						workspacePermission: undefined,
						invites: [],
					},
		updatePermissions,
		updatePublishMode,
	};
};
